import React from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import CompanyPage from "../pages/Company";
import CompanyHolidays from "../pages/CompanyHolidays";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import InternalChat from "../pages/InternalChat";
import InternalTickets from "../pages/InternalTickets";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags";
import TicketSubjects from "../pages/TicketSubjects";
import Companies from "../pages/Companies";
import Backups from "../pages/Backups";
import Announcements from "../pages/Announcements";
import DebugLogs from "../pages/DebugLogs";
import Attendances from "../pages/Attendances";
import Board from "../pages/Board";
import ApiTools from "../pages/ApiTools";
import Audit from "../pages/Audit";
import Ratings from "../pages/Ratings";
import Extensions from "../pages/Extensions";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import { InternalChatNotificationsProvider } from "../context/InternalChatNotifications/InternalChatNotificationsContext";
import BackdropLoading from "../components/BackdropLoading";
import useCompanySipEnabled from "../hooks/useCompanySipEnabled";
import Route from "./Route";

const ExtensionsRouteGate = () => {
  const { sipEnabled: isCompanySipEnabled, loading } = useCompanySipEnabled();

  if (loading) {
    return <BackdropLoading />;
  }

  if (!isCompanySipEnabled) {
    return <Redirect to="/" />;
  }

  return <Extensions />;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <InternalChatNotificationsProvider>
                <LoggedInLayout>
                  <Route exact path="/" component={Dashboard} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/internal-chat/:conversationId?" component={InternalChat} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/internal-tickets/:internalTicketId?" component={InternalTickets} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/connections" component={Connections} isPrivate roles={["admin"]} />
                  <Route exact path="/contacts" component={Contacts} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/users" component={Users} isPrivate roles={["admin", "superadmin"]} />
                  <Route exact path="/attendances" component={Attendances} isPrivate roles={["admin"]} />
                  <Route exact path="/monitoramento" component={Board} isPrivate roles={["admin"]} />
                  <Route exact path="/api-tools" component={ApiTools} isPrivate roles={["admin"]} />
                  <Route exact path="/audit" component={Audit} isPrivate roles={["admin"]} />
                  <Route exact path="/ratings" component={Ratings} isPrivate roles={["admin"]} />
                  <Route exact path="/company" component={CompanyPage} isPrivate roles={["admin"]} />
                  <Route exact path="/company-holidays" component={CompanyHolidays} isPrivate roles={["admin"]} />
                  <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate roles={["admin", "user"]} />
                  <Route exact path="/Settings" component={Settings} isPrivate roles={["admin"]} />
                  <Route exact path="/Queues" component={Queues} isPrivate roles={["admin"]} />
                  <Route exact path="/extensions" component={ExtensionsRouteGate} isPrivate roles={["admin"]} />
                  <Route exact path="/tags" component={Tags} isPrivate roles={["admin"]} />
                  <Route exact path="/ticket-subjects" component={TicketSubjects} isPrivate roles={["admin"]} />
                  <Route exact path="/companies" component={Companies} isPrivate roles={["superadmin"]} />
                  <Route exact path="/announcements" component={Announcements} isPrivate roles={["superadmin"]} />

                  <Route exact path="/debug-logs" component={DebugLogs} isPrivate roles={["superadmin"]} />
                  <Route exact path="/backups" component={Backups} isPrivate roles={["superadmin"]} />
                </LoggedInLayout>
              </InternalChatNotificationsProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
